import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { ReactComponent as ClosechipIcon } from '@assets/icons/close-chip.svg';

import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { capitalizeFirstLetter } from '@utils/Util';

const AddRole = () => {
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const [isManagement, setIsManagement] = useState(false);
	const [countryList, setCountryList] = useState([]);
	const [managementList, setManagementList] = useState([]);
	const [allDepartmentList, setAllDepartmentList] = useState([]);
	const [departmentList, setDepartmentList] = useState([]);
	const [userTypeList, setUserTypeList] = useState([]);
	const [menusList, setMenusList] = useState([]);
	const [mainMenuOptions, setMainMenuOptions] = useState([]);
	const [moreMenuOptions, setMoreMenuOptions] = useState([]);
	const [rolesgroupList, setRolesgroupList] = useState([]);
	const [managementType, setManagementType] = useState('');
	const [operationalZone, setOperationalZone] = useState([]);
	const [departments, setDepartments] = useState([]);
	const [primaryUserType, setPrimaryUserType] = useState('');
	const [mainMenuList, setMainMenuList] = useState([]);
	const [moreMenuList, setMoreMenuList] = useState([]);
	const [permissions, setPermissions] = useState([]);
	const [error, setError] = useState({});
	const navigate = useNavigate();

	useEffect(() => {
		ApiClient.GET('getCountryList').then(({ data }) => {
			let formatData = data.map((item) => ({
				value: item.id,
				label: item.name
			}));
			setCountryList(formatData);
		});

		ApiClient.GET('getEnums', 'info.nitex.app.user.ManagementLevel').then(({ data }) => {
			setManagementList(data);
		});

		ApiClient.GET('getDepartmentList').then(({ data }) => {
			setAllDepartmentList(data);
			let formatData = data.map((item) => ({
				value: item.id,
				label: item.name
			}));
			setDepartmentList(formatData);
		});

		ApiClient.GET('getAllMenus').then(({ data }) => {
			setMenusList(data);
		});

		ApiClient.GET('getGroupedRoleList').then(({ data }) => {
			setRolesgroupList(data);
		});
	}, []);

	useEffect(() => {
		let selectedMainMenuIds = mainMenuList.map((item) => item.id);
		let options = menusList
			.filter((item) => !selectedMainMenuIds.includes(item.id))
			.map((item) => {
				return { label: item.text, value: item.id };
			});
		setMainMenuOptions(options);
	}, [menusList, mainMenuList]);

	useEffect(() => {
		let selectedMoreMenuIds = moreMenuList.map((item) => item.id);
		let options = menusList
			.filter((item) => !selectedMoreMenuIds.includes(item.id))
			.map((item) => {
				return { label: item.text, value: item.id };
			});
		setMoreMenuOptions(options);
	}, [menusList, moreMenuList]);

	const onChangeDepartment = (selectedItem) => {
		setDepartments(selectedItem);
		let deptUserTypes = selectedItem.map((item) => item.label);
		let tempUserTypeList = [];
		for (let item of deptUserTypes) {
			let selecteduserTypes = allDepartmentList.find((singleItem) => singleItem.name === item);

			tempUserTypeList = [...tempUserTypeList, ...selecteduserTypes.userTypeSet];
		}
		setUserTypeList([...new Set(tempUserTypeList)]);
	};

	const closeUserType = (value) => {
		let removedDeptList = userTypeList.filter((item) => item !== value);
		setUserTypeList(removedDeptList);
	};

	const onMainMenuChange = (selectedItem) => {
		let menuObj = menusList.filter((item) => item.id == selectedItem.value);
		setMainMenuList([...mainMenuList, ...menuObj]);
	};

	const closeMainMenu = (value) => {
		let removedMainMenuList = mainMenuList.filter((item) => item.id !== value);
		setMainMenuList(removedMainMenuList);
	};

	const onMoreMenuChange = (selectedItem) => {
		let menuObj = menusList.filter((item) => item.id == selectedItem.value);
		setMoreMenuList([...moreMenuList, ...menuObj]);
	};

	const closeMoreMenu = (value) => {
		let removedMoreMenuList = moreMenuList.filter((item) => item.id !== value);
		setMoreMenuList(removedMoreMenuList);
	};

	const issAllSelected = (key) => {
		let selectedIds = rolesgroupList[key].map((item) => item.id);
		if (selectedIds.length === 0) {
			return false;
		}
		for (let i = 0; i < selectedIds.length; i++) {
			if (permissions.indexOf(selectedIds[i]) < 0) {
				return false;
			}
		}
		return true;
	};

	const onAllCheckboxClick = (key, value) => {
		if (issAllSelected(key)) {
			let listOfId = rolesgroupList[key].map((item) => item.id);
			let newPermission = permissions.filter((item) => !listOfId.includes(item));
			setPermissions(newPermission);
		} else {
			let listOfId = [];
			if (!(key in permissions) || value.length !== permissions[key]?.length) {
				listOfId = value.map((item) => item.id);
			}
			setPermissions((prev) => [...prev, ...listOfId]);
		}
	};

	const onSingleCheckboxClick = (key, id) => {
		if (permissions.includes(id)) {
			let newPermissions = permissions.filter((item) => item !== id);
			setPermissions(newPermissions);
		} else {
			setPermissions([...permissions, id]);
		}
	};

	const validateForm = () => {
		let cloneError = { ...error };
		if (!name) {
			cloneError.name = 'Role name is required';
		}

		if (isManagement) {
			if (!managementType) {
				cloneError.managementType = 'Management type name is required';
			}
			if (operationalZone.length === 0) {
				cloneError.operationalZone = 'Operational zone is required';
			}
		}
		if (departments.length === 0) {
			cloneError.departments = 'Department is required';
		}
		if (!primaryUserType) {
			cloneError.primaryUserType = 'Primary user type is required';
		}
		if (mainMenuList.length === 0) {
			cloneError.maninMenuList = 'Main menu is required';
		}
		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};

	const handleBlurEvent = (fieldName) => {
		if (fieldName === 'name' && name) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'isManagement' && isManagement) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'managementType' && managementType) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'operationalZone' && operationalZone.length > 0) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'departments' && departments.length > 0) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'primaryUserType' && primaryUserType) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'maninMenuList' && mainMenuList.length > 0) {
			setError({ ...error, [fieldName]: undefined });
		}
	};

	const addRoleInfo = () => {
		if (!validateForm()) {
			let postObj = {
				name: name,
				description: description,
				primaryUserType: primaryUserType,
				isManagement: isManagement,
				managementLevel: managementType,
				userTypeList: userTypeList,
				countryIdList: operationalZone.map((country) => country.value),
				departmentIdList: departments.map((department) => department.value),
				mainMenuList: mainMenuList.map((mainMenu) => mainMenu.id),
				moreMenuList: moreMenuList.map((moreMenu) => moreMenu.id),
				roleIdList: permissions
			};
			ApiClient.POST('addRole', postObj)
				.then(() => {
					toastSuccess('Successfully added');
					navigate('/admins/list?activeTab=ROLE');
				})
				.catch(() => {
					toastError('Something went wrong!');
				});
		}
	};

	const renderCheckbox = () => {
		let result = [];
		for (const [key, value] of Object.entries(rolesgroupList)) {
			result.push(
				<div className="row form-row">
					<div className="col-md-12">
						<label className="mb-4 pb-2 border-bottom semibold-16">{key}</label>
					</div>
					<div className="col-md-12">
						<div className="form-group">
							<div className="all-cat-select d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
								<div className="all-checkbox bg-gray-light p-3 mb-2 mb-sm-0">
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id={key}
												name="parent"
												value={key}
												onChange={() => onAllCheckboxClick(key, value)}
												checked={issAllSelected(key)}
											/>
											<label htmlFor={key} className="m-0">
												ALL
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="role-check-container flex-column flex-sm-row">
						{value.map((permission) => {
							return (
								<div className="custom-chekbox" key={permission.id}>
									<div className="form-group">
										<input
											type="checkbox"
											id={permission.name}
											name={permission.roleGroup}
											value={permission.id}
											onChange={() => onSingleCheckboxClick(key, permission.id)}
											checked={permissions?.includes(permission.id)}
										/>
										<label htmlFor={permission.name}>
											<span>{permission.text}</span>
										</label>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			);
		}
		return result;
	};

	const onReset = () => {
		setName('');
		setDescription('');
		setPrimaryUserType('');
		setIsManagement(false);
		setUserTypeList([]);
		setManagementType('');
		setOperationalZone([]);
		setDepartments([]);
		setMainMenuList([]);
		setMoreMenuList([]);
		setPermissions([]);
	};

	return (
		<>
			<div className="brand-container role-management-container">
				<div className="form-container">
					<div className="form-header pb-3">
						<p className="semibold-16">Add role</p>
					</div>
					<div className="container px-0">
						<div className="row form-row">
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="name">Role name</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type your role name"
										name="name"
										value={name}
										onChange={(e) => setName(e.target.value)}
										onBlur={() => handleBlurEvent('name')}
									/>
									{error.name && <p className="error">{error.name}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-2">
									<label htmlFor="Description">Description</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Description"
										name="description"
										value={description}
										onChange={(e) => setDescription(e.target.value)}
									/>
								</div>
							</div>
						</div>

						<div className="row form-row">
							<div className="col-md-6 pr-10">
								<div className="form-group">
									<label htmlFor="isManagement">Is management ?</label>
									<select
										name="isManagement"
										onChange={(e) => setIsManagement(e.target.value)}
										onBlur={() => handleBlurEvent('isManagement')}
									>
										<option value={true} selected={JSON.parse(isManagement)}>
											Yes
										</option>
										<option value={false} selected={!JSON.parse(isManagement)}>
											No
										</option>
									</select>
								</div>
							</div>
							<div className="col-md-6 pl-10">
								<div className="form-group">
									<label htmlFor="managementType">Select management type</label>
									<select
										name="managementType"
										disabled={!JSON.parse(isManagement)}
										onChange={(e) => setManagementType(e.target.value)}
										onBlur={() => handleBlurEvent('managementType')}
									>
										<option disabled selected>
											Select
										</option>
										{managementList.map((item) => {
											return (
												<option key={item.id} value={item.constant}>
													{item.name}
												</option>
											);
										})}
									</select>
									{error.managementType && <p className="error">{error.managementType}</p>}
								</div>
							</div>
							{JSON.parse(isManagement) && (
								<div className="col-md-12">
									<div className="form-group no-shadow-react-select">
										<label htmlFor="department">Operational Zone</label>
										<Select
											onChange={setOperationalZone}
											onBlur={() => handleBlurEvent('operationalZone')}
											value={operationalZone}
											isMulti
											options={countryList}
										/>
										{error.operationalZone && (
											<p className="error">{error.operationalZone}</p>
										)}
									</div>
								</div>
							)}

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="department">Department</label>
									<Select
										onChange={onChangeDepartment}
										onBlur={() => handleBlurEvent('departments')}
										value={departments}
										isMulti
										options={departmentList}
									/>
									{error.departments && <p className="error">{error.departments}</p>}
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group mb-0">
									<label htmlFor="primaryUserType">Primary User Type</label>
									<select
										name="primaryUserType"
										onChange={(e) => setPrimaryUserType(e.target.value)}
										onBlur={() => handleBlurEvent('primaryUserType')}
									>
										<option disabled selected>
											Select
										</option>
										{userTypeList.map((item) => {
											return (
												<option key={item} value={item}>
													{capitalizeFirstLetter(item.replace('_', ' '))}
												</option>
											);
										})}
									</select>
									{error.primaryUserType && (
										<p className="error">{error.primaryUserType}</p>
									)}
									<div className="role-chips d-flex flex-wrap mt-3">
										{userTypeList.map((item, i) => {
											return (
												<span className="chip mb-1" key={`user_type_${i}`}>
													{capitalizeFirstLetter(item.replace('_', ' '))}

													<span onClick={() => closeUserType(item)}>
														<ClosechipIcon />
													</span>
												</span>
											);
										})}
									</div>
								</div>
							</div>
						</div>

						<div className="row form-row">
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="mainMenu">Main Menu</label>
									<Select
										name="maninMenuList"
										options={mainMenuOptions}
										onChange={onMainMenuChange}
										onBlur={() => handleBlurEvent('maninMenuList')}
									/>
									{error.maninMenuList && <p className="error">{error.maninMenuList}</p>}
									<div className="role-chips d-flex flex-wrap mt-3">
										{mainMenuList.map((item) => {
											return (
												<span className="chip mb-1" key={`main_menu_${item.id}`}>
													{item.text}
													<span onClick={() => closeMainMenu(item.id)}>
														<ClosechipIcon />
													</span>
												</span>
											);
										})}
									</div>
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="mainMenu">More Menu</label>
									<Select
										name="moreMenuList"
										options={moreMenuOptions}
										onChange={(e) => onMoreMenuChange(e)}
									/>
									<div className="role-chips d-flex flex-wrap mt-3">
										{moreMenuList.map((item) => {
											return (
												<span className="chip mb-1" key={`more_menu_${item.id}`}>
													{item.text}
													<span onClick={() => closeMoreMenu(item.id)}>
														<ClosechipIcon />
													</span>
												</span>
											);
										})}
									</div>
								</div>
							</div>
						</div>

						{renderCheckbox()}

						<div className="row mb-3">
							<div className="col-md-12 text-right">
								<button className="button gray-outline mr-1 size32" onClick={onReset}>
									Reset
								</button>
								<button className="button ml-1 size32" onClick={addRoleInfo}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddRole;
